

import moment from "moment";

const columns = {
  titles: [
    "Meter Number",
    "Estate",
    "Email",
    "Status",
    "Date Added",
    "Action"
  ],

  columns($: any) {
    return [
      { data: "meterNumber" },
      { data: "estate" },
      { data: "email" },
      { data: "status" },
      {
        data: "createdAt",
        render: function (data: string) {
          return moment(data).format("DD/MM/YYYY HH:mm a");
        }
      },
      {
        data: null,
        orderable: false,
        searchable: false,
        render: function (_: any, __: any, row: any) {
          return `
            <div style="cursor: pointer;" class="action-icon" data-id="${row.id}">
              &#8942; <!-- vertical ellipsis icon -->
            </div>
          `;
        }
      }
    ];
  }
};

export default columns;
